import { createSlice } from "@reduxjs/toolkit";

const saved = JSON.parse(localStorage.getItem("cart")) || { items: [] };

const initialState = {
  items: saved.items.map((item) => ({
    ...item,
    price: Number(item.price) || 0,
    qty: Number(item.qty) || 0,
  })),
};

const slice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, { payload }) => {
      const safePrice = Number(payload.price) || 0;
      const qty = payload.qty ?? 1;

      const existing = state.items.find((i) => i.id === payload.id);

      if (existing) {
        if (payload.isFixedQty) {
          // Fixed product → overwrite
          existing.qty = qty;
          existing.price = safePrice;
          existing.finalAmount = payload.finalAmount;
          existing.courierCharges = payload.courierCharges;
        } else {
          // Non fixed → overwrite with selected qty
          existing.qty = qty;
          existing.price = safePrice;
          existing.finalAmount = qty * safePrice;
        }
      } else {
        state.items.push({
          ...payload,
          price: safePrice,
          qty,
          finalAmount: payload.finalAmount || qty * safePrice,
        });
      }

      localStorage.setItem("cart", JSON.stringify(state));
    },

    increaseQty: (state, { payload }) => {
      const item = state.items.find((i) => i.id === payload);
      if (item && !item.isFixedQty) {
        item.qty += 1;
        item.finalAmount = item.qty * item.price;
      }

      localStorage.setItem("cart", JSON.stringify(state));
    },

    decreaseQty: (state, { payload }) => {
      const item = state.items.find((i) => i.id === payload);
      if (!item) return;

      item.qty -= 1;

      if (item.qty <= 0) {
        state.items = state.items.filter((i) => i.id !== payload);
      } else {
        item.finalAmount = item.qty * item.price;
      }

      localStorage.setItem("cart", JSON.stringify(state));
    },

    removeItem: (state, { payload }) => {
      state.items = state.items.filter((i) => i.id !== payload);
      localStorage.setItem("cart", JSON.stringify(state));
    },

    clearCart: (state) => {
      state.items = [];
      localStorage.setItem("cart", JSON.stringify(state));
    },

    updateQtyFromDropdown: (state, action) => {
      const { id, qty, price, finalAmount, courierCharges } = action.payload;

      const item = state.items.find((i) => i.id === id);

      if (item) {
        item.qty = qty;
        item.price = Number(price) || 0;
        item.finalAmount = Number(finalAmount) || 0;
        item.courierCharges = courierCharges;
      }

      localStorage.setItem("cart", JSON.stringify(state));
    },
  },
});

export const {
  addItem,
  increaseQty,
  decreaseQty,
  removeItem,
  clearCart,
  updateQtyFromDropdown,
} = slice.actions;

export const selectCartItems = (s) => s.cart.items;

export const selectCartCount = (s) =>
  s.cart.items.reduce((n, i) => n + i.qty, 0);

export const selectCartTotal = (s) =>
  s.cart.items.reduce((sum, i) => {
    if (i.isFixedQty) {
      return sum + (Number(i.finalAmount) || 0);
    }
    return sum + i.qty * (Number(i.price) || 0);
  }, 0);

export default slice.reducer;
